<template>
  <div class="container">
    <!-- 支付成功卡片 -->
    <div class="success-card">
      <div class="status-icon">
        <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
          <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292c-12.8 17.6-39 17.6-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"/>
        </svg>
      </div>
      <h1 class="title">支付成功</h1>
      <p class="desc">请及时出场，以免再次产生停车费用！</p>
      
      <!-- 订单信息区域 -->
      <div class="order-info">
        <div class="info-row">
          <span class="info-label">订单编号</span>
          <span class="info-value">{{ orderInfo.orderNo }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">支付金额</span>
          <span class="info-value amount">¥{{ orderInfo.amount }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">支付时间</span>
          <span class="info-value">{{ orderInfo.payTime }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentSuccess',
  data() {
    return {
      orderInfo: {
        orderNo: 'WX20250922161503',
        amount: '88.00',
        payTime: '2025-09-22 16:15:03'
      }
    }
  },
  mounted() {
    this.initWechatGoldPlan();
    this.initOrderInfo();
  },
  methods: {
    // 初始化微信点金计划通信
    initWechatGoldPlan() {
      const mchData = {
        action: 'onIframeReady',
        displayStyle: 'SHOW_CUSTOM_PAGE'
      };
      const postData = JSON.stringify(mchData);
      window.parent.postMessage(postData, 'https://payapp.weixin.qq.com');
    },
    
    // 从URL参数获取订单信息
    initOrderInfo() {
      const params = new URLSearchParams(window.location.search);
      console.log(params);
      this.orderInfo = {
        orderNo: params.get('order_no') || this.orderInfo.orderNo,
        amount: params.get('amount') || this.orderInfo.amount,
        payTime: params.get('pay_time') || this.orderInfo.payTime
      }
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 375px;
  margin: 0 auto;
  padding: 20px;
  font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
}

.success-card {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.status-icon {
  color: #07C160;
  font-size: 48px;
  margin-bottom: 16px;
}

.title {
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #333;
}

.desc {
  font-size: 14px;
  color: #666;
  margin-bottom: 24px;
}

.order-info {
  margin: 24px 0;
  text-align: left;
}

.info-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  font-size: 14px;
}

.info-label {
  color: #999;
}

.info-value {
  color: #333;
}

.amount {
  color: #FF4D4F;
  font-weight: 500;
}

.action-btn {
  display: block;
  background: #07C160;
  color: white;
  text-align: center;
  padding: 12px;
  border-radius: 6px;
  text-decoration: none;
  font-size: 16px;
  margin-top: 24px;
}

.ad-container {
  margin-top: 20px;
  padding: 16px;
  background: #f7f7f7;
  border-radius: 8px;
}

.ad-placeholder {
  text-align: center;
  color: #999;
  padding: 20px 0;
}
</style>
